import { InfiniteDataQueryPage, PageDataWithCount } from '../useInfiniteDataQuery.types';

interface ToCachedPageParams<PageData> {
  page: PageDataWithCount<PageData>;
  currentPage: number;
  limit: number;
}

export class UseInfiniteDataQueryUtils {
  static toCachedPage<PageData>({
    page,
    currentPage,
    limit,
  }: ToCachedPageParams<PageData>): InfiniteDataQueryPage<PageData> {
    return {
      ...page,
      currentPage,
      isFullPage: (page.data?.length ?? 0) >= limit,
    };
  }
}
